// extracted by mini-css-extract-plugin
module.exports = {"button":"StoreButton_button__11x1f","google":"StoreButton_google__3-AlY","apple":"StoreButton_apple__3mAEu"};